export * from "-!../../../../node_modules/style-loader/index.js!../../../../node_modules/css-loader/index.js!../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../node_modules/sass-loader/lib/loader.js!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./bg-image.vue?vue&type=style&index=0&id=2b066fda&lang=scss"


//////////////////
// WEBPACK FOOTER
// ./src/js/components/bg-image/bg-image.vue?vue&type=style&index=0&id=2b066fda&lang=scss
// module id = ./src/js/components/bg-image/bg-image.vue?vue&type=style&index=0&id=2b066fda&lang=scss
// module chunks = 4 5